//window.location.href

import store from '../../store'
import * as $bg from './bridge.js'
import LINKTYPE from './linktype.js'

var sso = {};




sso.login = (lk) => {

	var fromapp = "wap";
	

	if ($bg.isSonyApp()) {
		fromapp = "app";
	}

	let redirect = window.location.href;
	redirect = redirect.replace(/(token(\=))+(\w+(-)?)+/, "");
	//need to configure for APP
	let ssoUrl = BASE_URL + "/content/dam/sonystyle-club/index.html#/?fromapp=" + fromapp;

	if ($bg.isSonyApp()) {
		if (lk && lk.linkFrom) {
			ssoUrl += "&linkFrom=" + lk.linkFrom;
		}
		//alert("Is SONY APP "+ssoUrl);
	}


	ssoUrl += "&redirect=" + encodeURIComponent(window.location.href);
	
	

	//alert("Final URL "+ssoUrl);

	if(!$bg.isSonyApp()){
		
		window.location.href = ssoUrl;
	}else{
		
		var ac={};
		
		ac.link_type=LINKTYPE.LOGIN;
		
		ac.link=ssoUrl;

		
		ac.action=LINKTYPE.makeAction(ac.link_type);
		ac.titleName="索尼中国";

		//alert("ssoUrl "+encodeURIComponent(ssoUrl));

		$bg.doAppAction(ac);
	}



}

sso.checkLogin = () => {

	var token = localStorage.getItem("access_token");
	if (token && token != "") {

		store.commit('setState', { access_token: token });

		return true;
	} else {

		return false;
	}

}

export default sso;


// WEBPACK FOOTER //
// ./src/commons/utils/sso.js